<template>
    <div>
        <navView :isSelect="isSelect" @handleCommand="handleCommand" />
        <div class="wrap">
            <img src="../assets/images/contact/bg.png" alt="">
            <div class="content">
                <h3>{{ $t('from.company') }}</h3>
                <p>{{ $t('from.aboutUs01') }}</p>
                <p>{{ $t('from.aboutUs02') }}</p>
            </div>
        </div>
        <div class="sub-title">Contact Us</div>
        <h2>{{ $t('from.contact') }}</h2>
        <div class="contact">
            <div class="contact-box">
                <img src="../assets/images/contact/phone.png" alt="">
                <div>85255399660</div>
            </div>
            <div class="contact-box">
                <img src="../assets/images/contact/email.png" alt="">
                <div>neo.sun@my.cityu.edu.hk</div>
            </div>
            <div class="contact-box">
                <img src="../assets/images/contact/location.png" alt="">
                <div>{{ $t('footer.location') }}</div>
            </div>
        </div>
        <footerView />
    </div>
</template>

<script >
import navView from '../components/nav.vue';
import footerView from '../components/footer.vue';
export default {
    components: {
        navView, footerView
    },
    data() {
        return {
            isSelect: 0,
        }
    },
    created() {
        console.log(this.$route.query)
        this.isSelect = this.$route.query.index
    },
    mounted() {

    },
    methods: {
        handleGoTop() {
            scrollTo(0, 0);
        },
        handleCommand(name) {
            if (name == 'en') {
                this.$i18n.locale = 'en'
            } else {
                this.$i18n.locale = 'zh'
            }
        }
    }
}
</script>

<style scoped lang="scss">
@media only screen and (max-width: 750px) {
    .sub-title {
        margin-top: 40px;

        h2 {
            font-size: 18px;
        }
    }

    .contact {
        border-top: 1px solid #cbcbcb;
        padding: 20px;

        .contact-box {

            margin-top: 20px;

            img {
                width: 40px;
                opacity: .7;
                margin: 0 auto;
                display: block;
            }

            div {
                line-height: 24px;
                font-size: 14px;
                font-weight: bold;
                text-align: center;
            }
        }
    }

    .wrap {
        box-sizing: border-box;
        padding: 70px 15px 15px;

        img {
            width: 100%;
        }

        .content {
            h3 {
                font-size: 18px;
                text-align: center;
                margin-top: 20px;
            }

            p {
                margin-top: 20px;
                font-size: 14px;
                word-wrap: break-word;
            }
        }
    }
}

@media only screen and (min-width: 751px) {
    .sub-title {
        margin-top: 60px;
    }

    .contact {
        border-top: 1px solid #cbcbcb;
        padding: 60px;

        .contact-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            margin-top: 40px;

            img {
                width: 80px;
                opacity: .7;
            }

            div {
                line-height: 80px;
                font-size: 40px;
                font-weight: bold;
                text-align: center;
            }
        }
    }

    .wrap {
        background-repeat: no-repeat;
        background-size: 100% 100vh;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        padding: 150px 30px 30px;

        .content {
            margin-left: 40px;
            max-width: 40%;


            h3 {
                font-size: 48px;
            }

            p {
                margin-top: 30px;
                font-size: 20px;
                word-wrap: break-word;
            }
        }
    }
}
</style>